import {ChangeDetectionStrategy, Component, input} from '@angular/core';

import {GraphStatistics} from '../../entities/graph-statistics.interface';

@Component({
	selector: 'ic-task-statistics',
	templateUrl: './task-statistics.component.html',
	styleUrls: ['./task-statistics.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class TaskStatisticsComponent {
	statistics = input<GraphStatistics[]>();
	completed = input<number>();
}
